import { ModalHistorialDetalleProcesoComponent } from './../components/core/layouts/modal-historial-detalle-proceso/modal-historial-detalle-proceso.component';
import { SancionesPersonasService } from './../components/core/containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-personas.service';
import { SancionesPersonasComponent } from './../components/core/containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-personas.component';
import { ReporteProductividadComponent } from './../components/core/containers/bandeja-principal/administrador/reportes/reporte-productividad/reporte-productividad.component';
//#region New services and component 2022
// Service
import { BaseServiceService } from './services/base-service.service';
// Components
import { CapacidadTecnicaComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/requisitos-generales/capacidad-tecnica/capacidad-tecnica.component';
import { CapacidadOperativaComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/requisitos-generales/capacidad-operativa/capacidad-operativa.component';
import { AtencionSolicitudComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/atencion-solicitud/atencion-solicitud.component';

//#endregion

//#region New services and component 2021
import { ActualizarRegistrosService } from './../components/core/containers/bandeja-principal/administrador/reportes/Actualizar-registros-rnt/actualizar-registros.service';
import { ActualizarRegistrosRntComponent } from './../components/core/containers/bandeja-principal/administrador/reportes/Actualizar-registros-rnt/actualizar-registros-rnt.component';

//#endregion

//#region Services
import { AuthService } from "./services/auth.service";
import { AuthGuardService } from "./guard/auth.guard";
import { HttpErrorHandler } from "./services/handle-error.service";
import { ProvidersInterceptors } from "./interceptor/providers.interceptor";
import { RequestCache } from "./services/abstract/request-cache.service";
import { RequestCacheWithMap } from "./services/request-cache-map.service";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioService } from "../components/core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service";
import { HomeService } from "../components/home/container/home.service";
import { RegistroCuentaService } from "../components/seguridad/containers/registrar/registro-cuenta.service";
import { PreguntasFrecuentesService } from "../components/contenido/containers/preguntas-frecuentes/preguntas-frecuentes.service";
import { LegislacionService } from "../components/contenido/containers/legislacion/legislacion.service";
import { ContactenosService } from "../components/contenido/containers/contactenos/contactenos.service";
import { BasicasLoVService } from "./services/basicas-lov.service";
import { CambiarContrasenaService } from "../components/seguridad/containers/cambiar-contrasena/cambiar-contrasena.service";
import { RecuperarContrasenaService } from "../components/seguridad/containers/recuperar-contrasena/recuperar-contrasena.service";
import { TerminosCondicionesService } from "./services/terminos-condiciones.service";
import { PerfilService } from "../components/seguridad/containers/perfil/perfil.service";
import { AlertsService } from "./services/alerts.service";
import { MenuService } from "../components/menu/menu.service";
import { SolicitudesService } from "../components/core/containers/bandeja-principal/funcionario/solicitudes/solicitudes.service";
import { TerminoService } from "../components/contenido/containers/termino/termino.service";
import { AuthExternoGuardService } from "./guard/auth_externo.guard";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionService } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion/completa-informacion.service";
// tslint:disable-next-line:max-line-length
import { CapacidadTecnicaService } from "../components/core/containers/bandeja-principal/prestador/pasos/capacidad/capacidad-tecnica.service";
// tslint:disable-next-line:max-line-length
import { CapacidadOperativaService } from "../components/core/containers/bandeja-principal/prestador/pasos/capacidad/capacidad-operativa.service";
// tslint:disable-next-line:max-line-length
import { TipoEstablecimientoService } from "../components/core/containers/bandeja-principal/prestador/pasos/tipo-establecimiento/tipo-establecimiento.service";
// tslint:disable-next-line:max-line-length
import { CodigoConductaService } from "../components/core/containers/bandeja-principal/prestador/pasos/codigo-conducta/codigo-conducta.service";
import { SolicitudService } from "../components/core/containers/bandeja-principal/prestador/solicitudes/solicitud.service";
import { AnotacionesService } from "./../components/core/containers/bandeja-principal/funcionario/anotaciones/anotaciones.service";
import { CertificadosService } from "./../components/core/containers/bandeja-principal/funcionario/trazabilidad/certificados.service";
// tslint:disable-next-line:max-line-length
import { ReportesRntsService } from "../components/core/containers/bandeja-principal/administrador/reportes/rnts/reportes-rnts.service";
// tslint:disable-next-line:max-line-length
import { ReportesPrestadoresService } from "./../components/core/containers/bandeja-principal/administrador/reportes/prestadores/reportes-prestadores.service";
// tslint:disable-next-line:max-line-length
import { ReportesEstablecimientosService } from "../components/core/containers/bandeja-principal/administrador/reportes/establecimientos/reportes-establecimientos.service";
// tslint:disable-next-line:max-line-length
import { ReportesTramitesService } from "../components/core/containers/bandeja-principal/administrador/reportes/tramites/reportes-tramites.service";
// tslint:disable-next-line:max-line-length
import { EstadisticosCamarasService } from "./../components/core/containers/bandeja-principal/administrador/reportes/estadisticos-camaras/estadisticos-camaras.service";
// tslint:disable-next-line:max-line-length
import { FormulariosComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/formularios/formularios.component";
// tslint:disable-next-line:max-line-length
import { FormulariosService } from "./../components/core/containers/bandeja-principal/administrador/reportes/formularios/formularios.service";
// tslint:disable-next-line:max-line-length
import { PagosParafiscalesService } from "../components/core/containers/bandeja-principal/administrador/reportes/pagos-parafiscales/pagos-parafiscales.service";
// tslint:disable-next-line:max-line-length
import { PagosParafiscalesComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/pagos-parafiscales/pagos-parafiscales.component";
import { FonturRntService } from "./../components/core/containers/bandeja-principal/administrador/reportes/fontur-rnt/fontur-rnt.service";
// tslint:disable-next-line:max-line-length
import { ReportesAnotacionesService } from "./../components/core/containers/bandeja-principal/administrador/reportes/anotaciones/reportes-anotaciones.service";
// tslint:disable-next-line: max-line-length
import { ReversarEstadoService } from "../components/core/containers/bandeja-principal/administrador/gestion/reversar-estado/reversar-estado.service";
import {VizualizacionNoSuperadaComponentService}from "../components/core/containers/bandeja-principal/administrador/reportes/vizualizacion-no-superada/vizualizacion-no-superada.component.service";

export const SERVICES = [
  AuthService,
  AuthGuardService,
  AuthExternoGuardService,
  AuthInactiveGuardService,
  RolGuardService,
  { provide: RequestCache, useClass: RequestCacheWithMap },
  ProvidersInterceptors,
  HttpErrorHandler,
  EstablecimientoComercioService,
  HomeService,
  RegistroCuentaService,
  PreguntasFrecuentesService,
  LegislacionService,
  ContactenosService,
  BasicasLoVService,
  CambiarContrasenaService,
  RecuperarContrasenaService,
  TerminosCondicionesService,
  PerfilService,
  AlertsService,
  MenuService,
  SolicitudesService,
  TerminoService,
  CompletaInformacionService,
  CompletaInformacionServiceGuia,
  CapacidadTecnicaService,
  CapacidadOperativaService,
  TipoEstablecimientoService,
  CodigoConductaService,
  SolicitudService,
  AnotacionesService,
  TutorialesService,
  CertificadosService,
  OtrasSolicitudesService,
  PagoParafiscalService,
  FonturService,
  EncuestaService,
  ArrendatarioService,
  DetalleSolicitudService,
  DetalleEstablecimientoService,
  DetalleCapacidadService,
  DetalleDocumentosService,
  NotificacionService,
  EncuestaFuncionarioService,
  RntService,
  DetalleSolicitudPrestadorService,
  ModalArriendoVehiculoService,
  CompletaInformacionServiceInmueble,
  CompletaInformacionServicePlataformas,
  ConfigurarCapacidadTecnicaService,
  ReasignacionSolicitudesService,
  TipoRNTService,
  DialogConfirmacionService,
  AnotacionService,
  AccionRntService,
  ConfiguracionInterfazService,
  ConfiguracionEmailContactenosService,
  ConfiguracionTipoInterfazService,
  MotivoDevolucionService,
  ModuloService,
  EntornoService,
  ConfLegislacionService,
  FormacionEmpleadoService,
  FaqSeccionService,
  UsuarioService,
  TipoTerminosCondicionesService,
  ConfTerminosCondicionesService,
  SubcategoriaService,
  RolService,
  OpcionRolService,
  RecursoAudiovisualService,
  OpcionModuloService,
  FaqService,
  CampoAdicionalService,
  CampoAdicionalCategoriaService,
  DocumentoService,
  DocumentoSubcategoriaService,
  DocumentoTipoTurismoAventuraService,
  ModuloEncuestaService,
  ModuloEncuestaSubcategoriaService,
  OpcionRespuestaAdicionalEncuestaService,
  OpcionRespuestaEncuestaService,
  PasoSolicitudService,
  PasoTipoSolicitudService,
  PreguntaAdicionalEncuestaService,
  PreguntaEncuestaService,
  ModalPreguntaListaValorService,
  ModalPreguntaEnlaceService,
  ModalPreguntaFormuladaService,
  ModalPreguntaCondicionadaService,
  ModalPreguntaCondicionBloqueoService,
  ModalConfiguracionExtraPreguntaService,
  SeccionEncuestaService,
  SubcategoriasTopesmlvService,
  TipoDatoService,
  TipoIdentificacionService,
  TipoPreguntaEncuestaService,
  TipoTurismoAventuraService,
  ActividadesEconomicasRntService,
  CategoriaService,
  ContenidoCertificadoService,
  DetalleTerminosCondicionesService,
  ParametroService,
  UsuarioRolService,
  EstablecimientoComercioSoloConsultaService,
  AyudasService,
  ModuloAyudaService,
  EstadoRntService,
  EstadoSolicitudService,
  ReportesSoloConsultaService,
  CambioPropietarioService,
  ConfiguracionCamaraService,
  ReportesRntsService,
  UtilService,
  ReportesPrestadoresService,
  SolicitudesConsultaService,
  RntConsultaService,
  ReportesEstablecimientosService,
  ReportesTramitesService,
  EstadisticosCamarasService,
  FormulariosService,
  PagosParafiscalesService,
  FonturRntService,
  ReportesAnotacionesService,
  EnviromentGlobalService,
  ReversarEstadoService,
  ReporteEncuestaService,
  ReporteEncuestaSatisfaccionService,
  ReportesCantidadRntService,
  ReportesCantidadRntEstadoService,
  SancionService,
  DepositarioProvisionalService,
  SuspensionService,
  ReactivacionService,
  ActualizarRegistrosService,
  BaseServiceService,
  ReportesCertificadoService,
  SancionesPersonasService,
  ReporteGeneralService,
  VizualizacionNoSuperadaComponentService,
];
//#endregion

//#region containers
import { HomeComponent } from "../components/home/container/home.component";
import { LoginComponent } from "../components/seguridad/containers/login/login.component";
import { RegistroCuentaComponent } from "../components/seguridad/containers/registrar/registro-cuenta.component";
import { CambiarContrasenaComponent } from "../components/seguridad/containers/cambiar-contrasena/cambiar-contrasena.component";
import { RecuperarContrasenaComponent } from "./../components/seguridad/containers/recuperar-contrasena/recuperar-contrasena.component";
import { ModalRecupContraComponent } from "../components/seguridad/layouts/modal-recup-contra/modal-recup-contra.component";
import { ModalCambiaContraComponent } from "../components/seguridad/layouts/modal-cambia-contra/modal-cambia-contra.component";
import { PerfilComponent } from "../components/seguridad/containers/perfil/perfil.component";
import { PreguntasFrecuentesComponent } from "../components/contenido/containers/preguntas-frecuentes/preguntas-frecuentes.component";
import { ContactenosComponent } from "../components/contenido/containers/contactenos/contactenos.component";
import { TutorialesComponent } from "../components/contenido/containers/tutoriales/tutoriales.component";
import { LegislacionComponent } from "../components/contenido/containers/legislacion/legislacion.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioComponent } from "../components/core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.component";
// tslint:disable-next-line:max-line-length
import { ModalTerminoCondicionesComponent } from "../components/seguridad/layouts/modal-termino-condiciones/modal-termino-condiciones.component";
import { ModalEstablecimientoComponent } from "../components/core/layouts/modal-establecimiento/modal-establecimiento.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesComponent as SolicitudesFuncionarioComponent } from "../components/core/containers/bandeja-principal/funcionario/solicitudes/solicitudes.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesComponent as SolicitudesPrestadorComponent } from "../components/core/containers/bandeja-principal/prestador/solicitudes/solicitudes.component";
import { TerminoComponent } from "../components/contenido/containers/termino/termino.component";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion/completa-informacion.component";
import { CapacidadComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/capacidad/capacidad.component";
// tslint:disable-next-line:max-line-length
import { TipoEstablecimientoComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/tipo-establecimiento/tipo-establecimiento.component";
// tslint:disable-next-line:max-line-length
import { CodigoConductaComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/codigo-conducta/codigo-conducta.component";
import { ModalCodigoConductaComponent } from "../components/core/layouts/modal-codigo-conducta/modal-codigo-conducta.component";
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from "../components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component";
// tslint:disable-next-line:max-line-length
import { OtrasSolicitudesComponent } from "../components/core/containers/bandeja-principal/prestador/otras-solicitudes/otras-solicitudes.component";
import { EncuestaComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/encuesta/encuesta.component";
// tslint:disable-next-line:max-line-length
import { PagoParafiscalComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/pago-parafiscal/pago-parafiscal.component";
import { AnotacionesComponent } from "../components/core/containers/bandeja-principal/funcionario/anotaciones/anotaciones.component";
// tslint:disable-next-line:max-line-length
import { ModalActividadEconomicaComponent } from "../components/seguridad/layouts/modal-actividad-economica/modal-actividad-economica.component";
import { CertificadosComponent } from "../components/core/containers/bandeja-principal/funcionario/trazabilidad/certificados.component";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionGuiaComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-guia/completa-informacion-guia.component";
import { ModalCorreoMensajeComponent } from "../components/core/layouts/modal-correo-mensaje/modal-correo-mensaje.component";
import { RutaNoExisteComponent } from "./layouts/ruta-no-existe/ruta-no-existe.component";
import { FonturComponent } from "../components/core/containers/bandeja-principal/prestador/pasos/fontur/fontur.component";
import { ModalArriendoVehiculoComponent } from "../components/core/layouts/modal-arriendo-vehiculo/modal-arriendo-vehiculo.component";
import { NotificacionComponent } from "../components/core/containers/bandeja-principal/prestador/notificacion/notificacion.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoConsultaExternaComponent } from "../components/core/containers/bandeja-principal/prestador/opciones/establecimiento/establecimiento.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudPrestadorComponent } from "../components/core/containers/bandeja-principal/prestador/detalle-solicitud/detalle-solicitud.component";
// tslint:disable-next-line:max-line-length
import { FonturRntComponent } from "./../components/core/containers/bandeja-principal/administrador/reportes/fontur-rnt/fontur-rnt.component";
// tslint:disable-next-line:max-line-length
import { ReportesAnotacionesComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/anotaciones/reportes-anotaciones.component";
import { ReversarEstadoComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/reversar-estado/reversar-estado.component";
import { ModalNuevaCategoriaComponent } from "../components/core/layouts/modal-nueva-categoria/modal-nueva-categoria.component";

export const CONTAINERS = [
  AssociateQuestionsComponent,
  ModalHistorialSancionPersonaComponent,
  CampoAdicionalListComponent,
  ReportesCertificadosComponent,
  ReporteProductividadComponent,
  AjustesRntComponent,
  AnotacionesAdminComponent,
  ReporteGeneralComponent,
  HomeComponent,
  LoginComponent,
  RegistroCuentaComponent,
  CambiarContrasenaComponent,
  RecuperarContrasenaComponent,
  ModalRecupContraComponent,
  ModalCambiaContraComponent,
  ModalConfirmacionSolicitudComponent,
  ModalTerminoCondicionesComponent,
  ModalTermino1581Component,
  ModalActividadEconomicaComponent,
  ModalEditarPerfilComponent,
  ModalConfirmarRespuestaComponent,
  ModalEditarEstadoComponent,
  ModalComentariosComponent,
  ModalHistorialDetalleProcesoComponent,
  ModalCorreoMensajeComponent,
  ModalAyudaComponent,
  PerfilComponent,
  PreguntasFrecuentesComponent,
  ContactenosComponent,
  TutorialesComponent,
  LegislacionComponent,
  EstablecimientoComercioComponent,
  ModalEstablecimientoComponent,
  SolicitudesPrestadorComponent,
  SolicitudesFuncionarioComponent,
  TerminoComponent,
  CompletaInformacionComponent,
  CapacidadComponent,
  TipoEstablecimientoComponent,
  CodigoConductaComponent,
  ModalCodigoConductaComponent,
  OtrasSolicitudesComponent,
  EncuestaComponent,
  PagoParafiscalComponent,
  AnotacionesComponent,
  CertificadosComponent,
  CompletaInformacionGuiaComponent,
  DetalleSolicitudComponent,
  EstablecimientoComponent,
  CapacidadFuncionarioComponent,
  DocumentosComponent,
  ArrendatarioComponent,
  EncuestaFuncionarioComponent,
  RntComponent,
  ParafiscalesFuncionarioComponent,
  InformacionComponent,
  RutaNoExisteComponent,
  FonturComponent,
  NotificacionComponent,
  ModalArriendoVehiculoComponent,
  ArriendoVehiculoComponent,
  DetalleSolicitudPrestadorComponent,
  EstablecimientoConsultaExternaComponent,
  CompletaInformacionInmueble,
  CompletaInformacionPlataformas,
  EstablecimientoConsultaExternaComponent,
  TiposRntComponent,
  ModalSeleccionTipoRntComponent,
  ReasignacionSolicitudesComponent,
  ModalCambioInmuebleComponent,
  ConfigurarCapacidadTecnicaComponent,
  SideMenu1Component,
  AnotacionComponent,
  AccionRntComponent,
  ConfiguracionInterfazComponent,
  ConfiguracionEmailContactenosComponent,
  ConfiguracionTipoInterfazComponent,
  MotivoDevolucionComponent,

  ModuloComponent,
  EntornoComponent,
  ConfLegislacionComponent,
  FormacionEmpleadoComponent,
  FaqSeccionComponent,
  UsuarioComponent,
  TipoTerminosCondicionesComponent,
  ConfTerminosCondicionesComponent,
  SubcategoriaComponent,
  RolComponent,
  OpcionRolComponent,
  RecursoAudiovisualComponent,
  OpcionModuloComponent,
  ModalSuspencionComponent,
  ModalCancelacionComponent,
  FaqComponent,
  CampoAdicionalComponent,
  CampoAdicionalCategoriaComponent,
  DocumentoComponent,
  DocumentoSubcategoriaComponent,
  DocumentoTipoTurismoAventuraComponent,
  ModuloEncuestaComponent,
  ModuloEncuestaSubcategoriaComponent,
  OpcionRespuestaAdicionalEncuestaComponent,
  OpcionRespuestaEncuestaComponent,
  PasoSolicitudComponent,
  PasoTipoSolicitudComponent,
  PreguntaAdicionalEncuestaComponent,
  PreguntaEncuestaComponent,
  SeccionEncuestaComponent,
  SubcategoriasTopesmlvComponent,
  TipoDatoComponent,
  TipoIdentificacionComponent,
  TipoPreguntaEncuestaComponent,
  TipoTurismoAventuraComponent,
  ActividadesEconomicasRntComponent,
  CategoriaComponent,
  ContenidoCertificadoComponent,
  DetalleTerminosCondicionesComponent,
  ParametroComponent,
  UsuarioRolComponent,
  EstablecimientoComercioSoloConsultaComponent,
  DetalleSolicitudSoloConsultaComponent,
  FonturFuncionarioComponent,
  AyudasComponent,
  CancelacionComponent,
  SuspensionComponent,
  ModuloAyudaComponent,
  MenuTemplate6Component,
  EstadoRntComponent,
  EstadoSolicitudComponent,
  ReportesSoloConsultaComponent,
  ModalGenerarAyudaComponent,
  ModalSeleccionUsuarioComponent,
  ModalSeleccionFuncionarioComponent,
  CambioPropietarioComponent,
  ReactivacionComponent,
  ConfiguracionCamaraComponent,
  ReportesRntsComponent,
  ReportesPrestadoresComponent,
  ReportesEstablecimientosComponent,
  SolicitudesConsultaComponent,
  RntConsultaComponent,
  ReportesTramitesComponent,
  EstadisticosCamarasComponent,
  FormulariosComponent,
  PagosParafiscalesComponent,
  FonturRntComponent,
  ReportesAnotacionesComponent,
  ReversarEstadoComponent,
  ReporteEncuestaComponent,
  ReporteEncuestaSatisfaccionComponent,
  ReportesCantidadRntComponent,
  ReportesCantidadRntEstadoComponent,
  ModalAceptarTerminosComponent,
  SancionComponent,
  DepositarioProvisionalComponent,
  ModalPreguntaListaValorComponent,
  ModalPreguntaEnlaceComponent,
  ModalPreguntaFormuladaComponent,
  ModalConfiguracionExtraPreguntaComponent,
  ModalPreguntaCondicionadaComponent,
  ModalPreguntaCondicionBloqueoComponent,
  ModalAsignarDepositarioComponent,
  ModalAsignarCancelacionComponent,
  ModalAsignarSuspensionComponent,
  ModalConfirmarEliminarDepositarioComponent,
  ModalAsignarReactivacionComponent,
  ActualizarRegistrosRntComponent,
  CapacidadTecnicaComponent,
  CapacidadOperativaComponent,
  AtencionSolicitudComponent,
  SancionesPersonasComponent,
  ReporteSancionesPersonasComponent,
  ModalNuevaCategoriaComponent,
  NotificacionesComponent,
  EncuestaSatisfaccionComponent,
  ModalEncuestaSatisfaccionPreguntasComponent,
  AsignarSancionesPersonaComponent,
  MunicipiosSinEstudioAutomaticoComponent,
  ExentoComponent,
  VizualizacionNoSuperadaComponent
];
//#endregion

//#region Presentational
import { MenuTemplate1Component } from "../components/menu/layouts/menu-template1/menu-template1.component";
import { TarjetaComponent } from "../components/home/layouts/tarjeta/tarjeta.component";
import { TarjetaPasosComponent } from "../components/home/layouts/tarjeta-pasos/tarjeta-pasos/tarjeta-pasos.component";
import { MenuTemplate2Component } from "../components/menu/layouts/menu-template2/menu-template2.component";
import { VistaSeguridadComponent } from "../components/seguridad/layouts/vista-seguridad/vista-seguridad.component";
import { ModalGenericoComponent } from "./layouts/modal-generico/modal-generico.component";
import { MenuTemplate3Component } from "../components/menu/layouts/menu-template3/menu-template3.component";
import { TablasComponent } from "../components/core/layouts/tablas/tablas.component";
import { TablasOrderComponent } from "../components/core/layouts/tablas-order/tablas-order.component";
import { MenuTemplate4Component } from "../components/menu/layouts/menu-template4/menu-template4.component";
import { MenuTemplate5Component } from "../components/menu/layouts/menu-template5/menu-template5.component";
import { AlertsComponent } from "./directives/alerts/alerts.component";
import { ModalEditarPerfilComponent } from "../components/seguridad/layouts/modal-editar-perfil/modal-editar-perfil.component";
import { TutorialesService } from "../components/contenido/containers/tutoriales/tutoriales.service";
import { ModalConfirmarRespuestaComponent } from "./layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import { FilterPipe } from "./directives/pipes/filter.pipe";
import { ActivoPipe } from "./directives/pipes/activo.pipe";
// tslint:disable-next-line:max-line-length
import OtrasSolicitudesService from "../components/core/containers/bandeja-principal/prestador/otras-solicitudes/otras-solicitudes.service";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionServiceGuia } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-guia/completa-informacion-guia.service";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudComponent } from "../components/core/containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/establecimiento/establecimiento.component";
// tslint:disable-next-line:max-line-length
import { CapacidadFuncionarioComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/capacidad-funcionario/capacidad-funcionario.component";
import { DocumentosComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/documentos/documentos.component";
// tslint:disable-next-line:max-line-length
import { PagoParafiscalService } from "../components/core/containers/bandeja-principal/prestador/pasos/pago-parafiscal/pago-parafiscal.service";
import { FonturService } from "../components/core/containers/bandeja-principal/prestador/pasos/fontur/fontur.service";
import { EncuestaService } from "../components/core/containers/bandeja-principal/prestador/pasos/encuesta/encuesta.service";
import { ArrendatarioService } from "../components/core/containers/bandeja-principal/prestador/arrendatario/arrendatario.service";
import { ArrendatarioComponent } from "../components/core/containers/bandeja-principal/prestador/arrendatario/arrendatario.component";
import { ModalEditarEstadoComponent } from "../components/core/layouts/modal-editar-estado/modal-editar-estado.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudService } from "../components/core/containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.service";
import { ModalComentariosComponent } from "../components/core/layouts/modal-comentarios/modal-comentarios.component";
// tslint:disable-next-line:max-line-length
import { EncuestaFuncionarioComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/encuesta-funcionario/encuesta-funcionario.component";
import { RntComponent } from "../components/core/containers/bandeja-principal/funcionario/rnts/rnt.component";
// tslint:disable-next-line:max-line-length
import { ParafiscalesFuncionarioComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/parafiscales-funcionario/parafiscales-funcionario.component";
// tslint:disable-next-line:max-line-length
import { InformacionComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/informacion/informacion.component";
// tslint:disable-next-line:max-line-length
import { DetalleEstablecimientoService } from "../components/core/containers/bandeja-principal/funcionario/opciones/establecimiento/establecimiento.service";
// tslint:disable-next-line:max-line-length
import { DetalleCapacidadService } from "../components/core/containers/bandeja-principal/funcionario/opciones/capacidad-funcionario/capacidad-funcionario.service";
// tslint:disable-next-line:max-line-length
import { DetalleDocumentosService } from "../components/core/containers/bandeja-principal/funcionario/opciones/documentos/documentos.service";

import { NotificacionService } from "../components/core/containers/bandeja-principal/prestador/notificacion/notificacion.service";
// tslint:disable-next-line:max-line-length
import { EncuestaFuncionarioService } from "../components/core/containers/bandeja-principal/funcionario/opciones/encuesta-funcionario/encuesta-funcionario.service";
import { RntService } from "../components/core/containers/bandeja-principal/funcionario/rnts/rnt.service";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudPrestadorService } from "../components/core/containers/bandeja-principal/prestador/detalle-solicitud/detalle-solicitud.service";
import { AuthInactiveGuardService } from "./guard/auth_inactive.guard";
import { RolGuardService } from "./guard/rol.guard";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionInmueble } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-inmueble/completa-informacion-inmueble.component";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionServiceInmueble } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-inmueble/completa-informacion-inmueble.service";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionPlataformas } from '../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-plataformas/completa-informacion-plataformas.component';
// tslint:disable-next-line:max-line-length
import { CompletaInformacionServicePlataformas } from "../components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-plataformas/completa-informacion-plataformas.service";
// tslint:disable-next-line:max-line-length
import { TiposRntComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipos-rnt/tipos-rnt.component";
import { ModalSeleccionTipoRntComponent } from "../components/core/layouts/modal-seleccion-tipo-rnt/modal-seleccion-tipo-rnt.component";
import { ModalArriendoVehiculoService } from "../components/core/layouts/modal-arriendo-vehiculo/modal-arriendo-vehiculo.service";
// tslint:disable-next-line:max-line-length
import { ReasignacionSolicitudesComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/reasignacion-solicitudes/reasignacion-solicitudes.component";
import { ModalCambioInmuebleComponent } from "../components/core/layouts/modal-cambio-inmueble/modal-cambio-inmueble.component";
// tslint:disable-next-line:max-line-length
import { ConfigurarCapacidadTecnicaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/configurar-capacidad-tecnica/configurar-capacidad-tecnica.service";
// tslint:disable-next-line:max-line-length
import { ReasignacionSolicitudesService } from "../components/core/containers/bandeja-principal/administrador/gestion/reasignacion-solicitudes/reasignacion-solicitudes.service";
// tslint:disable-next-line:max-line-length
import { TipoRNTService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipos-rnt/tipos-rnt.service";
import { DialogConfirmacionService } from "./services/dialog-confirmacion.service";
// tslint:disable-next-line:max-line-length
import { ConfigurarCapacidadTecnicaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/configurar-capacidad-tecnica/configurar-capacidad-tecnica.component";
// tslint:disable-next-line:max-line-length
import { SideMenu1Component } from "../components/menu/layouts/side-menu1/side-menu1.component";
import { AnotacionComponent } from "../components/core/containers/bandeja-principal/prestador/anotacion/anotacion.component";
import { AnotacionService } from "../components/core/containers/bandeja-principal/prestador/anotacion/anotacion.service";
// tslint:disable-next-line:max-line-length
import { AccionRntComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/accion-rnt/accion-rnt.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionInterfazComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-interfaz/configuracion-interfaz.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionEmailContactenosComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-email-contactenos/configuracion-email-contactenos.component";
// tslint:disable-next-line:max-line-length
import { AccionRntService } from "../components/core/containers/bandeja-principal/administrador/configuracion/accion-rnt/accion-rnt.service";
// tslint:disable-next-line:max-line-length
import { EstadoRntComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/estado-rnt/estado-rnt.component";
// tslint:disable-next-line:max-line-length
import { EstadoRntService } from "../components/core/containers/bandeja-principal/administrador/configuracion/estado-rnt/estado-rnt.service";
// tslint:disable-next-line:max-line-length
import { EstadoSolicitudComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/estado-solicitud/estado-solicitud.component";
// tslint:disable-next-line:max-line-length
import { EstadoSolicitudService } from "../components/core/containers/bandeja-principal/administrador/configuracion/estado-solicitud/estado-solicitud.service";
// tslint:disable-next-line:max-line-length
import { ConfiguracionInterfazService } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-interfaz/configuracion-interfaz.service";
// tslint:disable-next-line:max-line-length
import { ConfiguracionEmailContactenosService } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-email-contactenos/configuracion-email-contactenos.service";
// tslint:disable-next-line:max-line-length
import { ConfiguracionTipoInterfazComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-tipo-interfaz/configuracion-tipo-interfaz.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionTipoInterfazService } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-tipo-interfaz/configuracion-tipo-interfaz.service";
// tslint:disable-next-line:max-line-length
import { MotivoDevolucionComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/motivo-devolucion/motivo-devolucion.component";
import { ModuloComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo/modulo.component";
import { EntornoComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/entorno/entorno.component";
// tslint:disable-next-line:max-line-length
import { FormacionEmpleadoComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/formacion-empleado/formacion-empleado.component";
// tslint:disable-next-line:max-line-length
import { FaqSeccionComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/faq-seccion/faq-seccion.component";
// tslint:disable-next-line:max-line-length
import { MotivoDevolucionService } from "../components/core/containers/bandeja-principal/administrador/configuracion/motivo-devolucion/motivo-devolucion.service";
import { ModuloService } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo/modulo.service";
import { EntornoService } from "../components/core/containers/bandeja-principal/administrador/configuracion/entorno/entorno.service";
// tslint:disable-next-line:max-line-length
import { FormacionEmpleadoService } from "../components/core/containers/bandeja-principal/administrador/configuracion/formacion-empleado/formacion-empleado.service";
// tslint:disable-next-line:max-line-length
import { FaqSeccionService } from "../components/core/containers/bandeja-principal/administrador/configuracion/faq-seccion/faq-seccion.service";
// tslint:disable-next-line:max-line-length
import { ConfLegislacionComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/legislacion/legislacion.component";
// tslint:disable-next-line:max-line-length
import { ConfLegislacionService } from "../components/core/containers/bandeja-principal/administrador/configuracion/legislacion/legislacion.service";
import { UsuarioComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/usuario/usuario.component";
// tslint:disable-next-line:max-line-length
import { TipoTerminosCondicionesComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-terminos-condiciones/tipo-terminos-condiciones.component";
// tslint:disable-next-line:max-line-length
import { SubcategoriaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/subcategoria/subcategoria.component";
// tslint:disable-next-line:max-line-length
import { RolComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/rol/rol.component";
// tslint:disable-next-line:max-line-length
import { OpcionRolComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-rol/opcion-rol.component";
// tslint:disable-next-line:max-line-length
import { RecursoAudiovisualComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/recurso-audiovisual/recurso-audiovisual.component";
import { UsuarioService } from "../components/core/containers/bandeja-principal/administrador/configuracion/usuario/usuario.service";
// tslint:disable-next-line:max-line-length
import { TipoTerminosCondicionesService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-terminos-condiciones/tipo-terminos-condiciones.service";
// tslint:disable-next-line:max-line-length
import { ConfTerminosCondicionesService } from "../components/core/containers/bandeja-principal/administrador/configuracion/terminos-condiciones/terminos-condiciones.service";
// tslint:disable-next-line:max-line-length
import { SubcategoriaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/subcategoria/subcategoria.service";
// tslint:disable-next-line:max-line-length
import { RolService } from "../components/core/containers/bandeja-principal/administrador/configuracion/rol/rol.service";
// tslint:disable-next-line:max-line-length
import { OpcionRolService } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-rol/opcion-rol.service";
// tslint:disable-next-line:max-line-length
import { RecursoAudiovisualService } from "../components/core/containers/bandeja-principal/administrador/configuracion/recurso-audiovisual/recurso-audiovisual.service";
// tslint:disable-next-line:max-line-length
import { ConfTerminosCondicionesComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/terminos-condiciones/terminos-condiciones.component";
// tslint:disable-next-line:max-line-length
import { OpcionModuloComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-modulo/opcion-modulo.component";
// tslint:disable-next-line:max-line-length
import { OpcionModuloService } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-modulo/opcion-modulo.service";
import { ModalSuspencionComponent } from "../components/core/layouts/modal-suspencion/modal-suspencion.component";
import { ModalCancelacionComponent } from "../components/core/layouts/modal-cancelacion/modal-cancelacion.component";
import { FaqComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/faq/faq.component";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional/campo-adicional.component";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalCategoriaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional-categoria/campo-adicional-categoria.component";
// tslint:disable-next-line:max-line-length
import { DocumentoComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento/documento.component";
// tslint:disable-next-line:max-line-length
import { DocumentoSubcategoriaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento-subcategoria/documento-subcategoria.component";
// tslint:disable-next-line:max-line-length
import { DocumentoTipoTurismoAventuraComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento-tipo-turismo-aventura/documento-tipo-turismo-aventura.component";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta/modulo-encuesta.component";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaSubcategoriaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta-subcategoria/modulo-encuesta-subcategoria.component";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaAdicionalEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-adicional-encuesta/opcion-respuesta-adicional-encuesta.component";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-encuesta/opcion-respuesta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { PasoSolicitudComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/paso-solicitud/paso-solicitud.component";
// tslint:disable-next-line:max-line-length
import { PasoTipoSolicitudComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/paso-tipo-solicitud/paso-tipo-solicitud.component";
// tslint:disable-next-line:max-line-length
import { PreguntaAdicionalEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/pregunta-adicional-encuesta/pregunta-adicional-encuesta.component";
// tslint:disable-next-line:max-line-length
import { PreguntaEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/pregunta-encuesta/pregunta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { SeccionEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/seccion-encuesta/seccion-encuesta.component";
// tslint:disable-next-line:max-line-length
import { SubcategoriasTopesmlvComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/subcategorias-topesmlv/subcategorias-topesmlv.component";
// tslint:disable-next-line:max-line-length
import { TipoDatoComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-dato/tipo-dato.component";
// tslint:disable-next-line:max-line-length
import { TipoIdentificacionComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-identificacion/tipo-identificacion.component";
// tslint:disable-next-line:max-line-length
import { TipoPreguntaEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-pregunta-encuesta/tipo-pregunta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { TipoTurismoAventuraComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-turismo-aventura/tipo-turismo-aventura.component";
// tslint:disable-next-line:max-line-length
import { ActividadesEconomicasRntComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/actividades-economicas-rnt/actividades-economicas-rnt.component";
// tslint:disable-next-line:max-line-length
import { CategoriaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/categoria/categoria.component";
// tslint:disable-next-line:max-line-length
import { ContenidoCertificadoComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/contenido-certificado/contenido-certificado.component";
// tslint:disable-next-line:max-line-length
import { DetalleTerminosCondicionesComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/detalle-terminos-condiciones/detalle-terminos-condiciones.component";
// tslint:disable-next-line:max-line-length
import { ParametroComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/parametro/parametro.component";
// tslint:disable-next-line:max-line-length
import { UsuarioRolComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/usuario-rol/usuario-rol.component";
// tslint:disable-next-line:max-line-length
import { FaqService } from "../components/core/containers/bandeja-principal/administrador/configuracion/faq/faq.service";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalService } from "../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional/campo-adicional.service";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalCategoriaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
// tslint:disable-next-line:max-line-length
import { DocumentoService } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento/documento.service";
// tslint:disable-next-line:max-line-length
import { DocumentoSubcategoriaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento-subcategoria/documento-subcategoria.service";
// tslint:disable-next-line:max-line-length
import { DocumentoTipoTurismoAventuraService } from "../components/core/containers/bandeja-principal/administrador/configuracion/documento-tipo-turismo-aventura/documento-tipo-turismo-aventura.service";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta/modulo-encuesta.service";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaSubcategoriaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta-subcategoria/modulo-encuesta-subcategoria.service";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaAdicionalEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-adicional-encuesta/opcion-respuesta-adicional-encuesta.service";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-encuesta/opcion-respuesta-encuesta.service";
// tslint:disable-next-line:max-line-length
import { PasoSolicitudService } from "../components/core/containers/bandeja-principal/administrador/configuracion/paso-solicitud/paso-solicitud.service";
// tslint:disable-next-line:max-line-length
import { PasoTipoSolicitudService } from "../components/core/containers/bandeja-principal/administrador/configuracion/paso-tipo-solicitud/paso-tipo-solicitud.service";
// tslint:disable-next-line:max-line-length
import { PreguntaAdicionalEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/pregunta-adicional-encuesta/pregunta-adicional-encuesta.service";
// tslint:disable-next-line:max-line-length
import { PreguntaEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/pregunta-encuesta/pregunta-encuesta.service";
// tslint:disable-next-line:max-line-length
import { ModalPreguntaListaValorService } from "../components/core/layouts/modal-pregunta-lista-valor/modal-pregunta-lista-valor.service";
// tslint:disable-next-line:max-line-length
import { ModalPreguntaEnlaceService } from "../components/core/layouts/modal-pregunta-enlace/modal-pregunta-enlace.service";
// tslint:disable-next-line:max-line-length
import { ModalPreguntaFormuladaService } from "../components/core/layouts/modal-pregunta-formulada/modal-pregunta-formulada.service";
// tslint:disable-next-line:max-line-length
import { ModalPreguntaCondicionadaService } from "../components/core/layouts/modal-pregunta-condicionada/modal-pregunta-condicionada.service";
// tslint:disable-next-line:max-line-length
import { ModalPreguntaCondicionBloqueoService } from "../components/core/layouts/modal-pregunta-condicion-bloqueo/modal-pregunta-condicion-bloqueo.service";
// tslint:disable-next-line:max-line-length
import { SeccionEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/seccion-encuesta/seccion-encuesta.service";
// tslint:disable-next-line:max-line-length
import { SubcategoriasTopesmlvService } from "../components/core/containers/bandeja-principal/administrador/configuracion/subcategorias-topesmlv/subcategorias-topesmlv.service";
import { TipoDatoService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-dato/tipo-dato.service";
// tslint:disable-next-line:max-line-length
import { TipoIdentificacionService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-identificacion/tipo-identificacion.service";
// tslint:disable-next-line:max-line-length
import { TipoPreguntaEncuestaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-pregunta-encuesta/tipo-pregunta-encuesta.service";
// tslint:disable-next-line:max-line-length
import { TipoTurismoAventuraService } from "../components/core/containers/bandeja-principal/administrador/configuracion/tipo-turismo-aventura/tipo-turismo-aventura.service";
// tslint:disable-next-line:max-line-length
import { ActividadesEconomicasRntService } from "../components/core/containers/bandeja-principal/administrador/configuracion/actividades-economicas-rnt/actividades-economicas-rnt.service";
// tslint:disable-next-line:max-line-length
import { CategoriaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/categoria/categoria.service";
// tslint:disable-next-line:max-line-length
import { ContenidoCertificadoService } from "../components/core/containers/bandeja-principal/administrador/configuracion/contenido-certificado/contenido-certificado.service";
// tslint:disable-next-line:max-line-length
import { DetalleTerminosCondicionesService } from "../components/core/containers/bandeja-principal/administrador/configuracion/detalle-terminos-condiciones/detalle-terminos-condiciones.service";
import { ParametroService } from "../components/core/containers/bandeja-principal/administrador/configuracion/parametro/parametro.service";
// tslint:disable-next-line:max-line-length
import { UsuarioRolService } from "../components/core/containers/bandeja-principal/administrador/configuracion/usuario-rol/usuario-rol.service";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioSoloConsultaService } from "../components/core/containers/bandeja-principal/solo-consulta/establecimiento-comercio/establecimiento-comercio.service";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioSoloConsultaComponent } from "../components/core/containers/bandeja-principal/solo-consulta/establecimiento-comercio/establecimiento-comercio.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudSoloConsultaComponent } from "../components/core/containers/bandeja-principal/solo-consulta/detalle-solicitud/detalle-solicitud.component";
import { FonturFuncionarioComponent } from "../components/core/containers/bandeja-principal/funcionario/opciones/fontur/fontur.component";
import { AyudasComponent } from "../components/contenido/containers/ayudas/ayudas.component";
import { AyudasService } from "../components/contenido/containers/ayudas/ayudas.service";
// tslint:disable-next-line:max-line-length
import { CancelacionComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/cancelacion/cancelacion.component";
import { SuspensionComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/suspension/suspension.component";
import { ModalTermino1581Component } from "../components/contenido/layouts/modal-termino-1581/modal-termino-1581.component";
// tslint:disable-next-line:max-line-length
import { ModuloAyudaService } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-ayuda/modulo-ayuda.service";
// tslint:disable-next-line:max-line-length
import { ModuloAyudaComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/modulo-ayuda/modulo-ayuda.component";
// tslint:disable-next-line:max-line-length
import { ArriendoVehiculoComponent } from "../components/core/containers/bandeja-principal/prestador/arriendo-vehiculo/arriendo-vehiculo.component";
import { ModalGenerarAyudaComponent } from "../components/core/layouts/modal-generar-ayuda/modal-generar-ayuda.component";
import { ModalAyudaComponent } from "../components/core/layouts/modal-ayudas/modal-ayuda.component";
import { MenuTemplate6Component } from "../components/menu/layouts/menu-template6/menu-template6.component";
import { ReportesSoloConsultaService } from "../components/core/containers/bandeja-principal/solo-consulta/reportes/reportes.service";
import { ReportesSoloConsultaComponent } from "../components/core/containers/bandeja-principal/solo-consulta/reportes/reportes.component";
import { ModalSeleccionUsuarioComponent } from "../components/core/layouts/modal-seleccion-usuario/modal-seleccion-usuario.component";
// tslint:disable-next-line:max-line-length
import { CambioPropietarioService } from "../components/core/containers/bandeja-principal/administrador/configuracion/cambio-propietario/cambio-propietario.service";
// tslint:disable-next-line:max-line-length
import { CambioPropietarioComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/cambio-propietario/cambio-propietario.component";
// tslint:disable-next-line:max-line-length
import { ReactivacionComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/reactivacion/reactivacion.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionCamaraService } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-camara/configuracion-camara.service";
// tslint:disable-next-line:max-line-length
import { ConfiguracionCamaraComponent } from "../components/core/containers/bandeja-principal/administrador/configuracion/configuracion-camara/configuracion-camara.component";
// tslint:disable-next-line:max-line-length
import { ReportesRntsComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/rnts/reportes-rnts.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesConsultaComponent } from "../components/core/containers/bandeja-principal/funcionario/solicitudes-consulta/solicitudes-consulta.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesConsultaService } from "../components/core/containers/bandeja-principal/funcionario/solicitudes-consulta/solicitudes-consulta.service";
import { RntConsultaComponent } from "../components/core/containers/bandeja-principal/funcionario/rnts-consulta/rnt-consulta.component";
import { RntConsultaService } from "../components/core/containers/bandeja-principal/funcionario/rnts-consulta/rnt-consulta.service";
// tslint:disable-next-line:max-line-length
import { ReportesEstablecimientosComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/establecimientos/reportes-establecimientos.component";
// tslint:disable-next-line:max-line-length
import { ReportesTramitesComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/tramites/reportes-tramites.component";
// tslint:disable-next-line:max-line-length
import { ReportesPrestadoresComponent } from "./../components/core/containers/bandeja-principal/administrador/reportes/prestadores/reportes-prestadores.component";
// tslint:disable-next-line:max-line-length
import { EstadisticosCamarasComponent } from "./../components/core/containers/bandeja-principal/administrador/reportes/estadisticos-camaras/estadisticos-camaras.component";
// tslint:disable-next-line:max-line-length
import { ModalSeleccionFuncionarioComponent } from "../components/core/layouts/modal-seleccion-funcionario/modal-seleccion-funcionario.component";
import { EnviromentGlobalService } from "./services/enviroment-global.service";
import { ReporteEncuestaComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/encuesta/reporte-encuesta.component";
import { ReporteEncuestaSatisfaccionComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/reporte-encuesta-satisfaccion/reporte-encuesta-satisfaccion.component";
import { ReporteEncuestaService } from "../components/core/containers/bandeja-principal/administrador/reportes/encuesta/reporte-encuesta.service";
import { ReporteEncuestaSatisfaccionService } from "../components/core/containers/bandeja-principal/administrador/reportes/reporte-encuesta-satisfaccion/reporte-encuesta-satisfaccion.service";
import { ReportesCantidadRntService } from "../components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts/reportes-cantidad-rnt.service";
import { ReportesCantidadRntComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts/reportes-cantidad-rnt.component";
import { ReportesCantidadRntEstadoComponent } from "../components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts-estado/reportes-cantidad-rnt-estado.component";
import { ReportesCantidadRntEstadoService } from "../components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts-estado/reportes-cantidad-rnt-estado.service";
import { ModalAceptarTerminosComponent } from "../components/core/layouts/modal-aceptar-terminos/modal-aceptar-terminos.component";
import { SancionService } from "../components/core/containers/bandeja-principal/administrador/gestion/sancion/sancion.service";
import { DepositarioProvisionalService } from "../components/core/containers/bandeja-principal/administrador/gestion/depositario-provisional/depositario-provisional.service";
import { SancionComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/sancion/sancion.component";
import { DepositarioProvisionalComponent } from "../components/core/containers/bandeja-principal/administrador/gestion/depositario-provisional/depositario-provisional.component";
import { ModalPreguntaListaValorComponent } from "../components/core/layouts/modal-pregunta-lista-valor/modal-pregunta-lista-valor.component";
import { ModalPreguntaEnlaceComponent } from "../components/core/layouts/modal-pregunta-enlace/modal-pregunta-enlace.component";
import { ModalPreguntaCondicionadaComponent } from "../components/core/layouts/modal-pregunta-condicionada/modal-pregunta-condicionada.component";
import { ModalPreguntaCondicionBloqueoComponent } from "../components/core/layouts/modal-pregunta-condicion-bloqueo/modal-pregunta-condicion-bloqueo.component";
import { ModalAsignarDepositarioComponent } from "../components/core/layouts/modal-asignar-depositario/modal-asignar-depositario.component";
import { ModalPreguntaFormuladaComponent } from "../components/core/layouts/modal-pregunta-formulada/modal-pregunta-formulada.component";
import { ModalAsignarCancelacionComponent } from "../components/core/layouts/modal-asignar-cancelacion/modal-asignar-cancelacion.component";
import { ModalAsignarSuspensionComponent } from "../components/core/layouts/modal-asignar-suspension/modal-asignar-suspension.component";
import { ModalConfirmarEliminarDepositarioComponent } from "../components/core/layouts/modal-confirmar-eliminar-depositario/modal-confirmar-eliminar-depositario.component";
import { SuspensionService } from "../components/core/containers/bandeja-principal/administrador/gestion/suspension/suspension.service";
import { ModalAsignarReactivacionComponent } from "../components/core/layouts/modal-asignar-reactivacion/modal-asignar-reactivacion.component";
import { ReactivacionService } from "../components/core/containers/bandeja-principal/administrador/gestion/reactivacion/reactivacion.service";
import { ModalConfiguracionExtraPreguntaService } from "../components/core/layouts/modal-configuracion-extra-pregunta/modal-configuracion-extra-pregunta.service";
import { ModalConfiguracionExtraPreguntaComponent } from "../components/core/layouts/modal-configuracion-extra-pregunta/modal-configuracion-extra-pregunta.component";
import { ModalValidarActividadesEconomicasComponent } from '../components/core/layouts/modal-validar-actividades-economicas/modal-validar-actividades-economicas.component';
import { ModalCapturaDireccionComponent } from '../components/core/layouts/modal-captura-direccion/modal-captura-direccion.component';
import { ExentoComponent } from '../components/core/containers/bandeja-principal/administrador/gestion/exento/exento.component';
import { VizualizacionNoSuperadaComponent } from '../components/core/containers/bandeja-principal/administrador/reportes/vizualizacion-no-superada/vizualizacion-no-superada.component';

export const LAYOUTS = [
  MenuTemplate1Component,
  TarjetaComponent,
  ModalEncuestaSatisfaccionComponent,
  ModalCategoriaEstablecimientoComponent,
  ModalListaCategoriasComponent,
  ModalTiposSolicitudSubcategoriaComponent,
  ModalModificarSancionPersonaComponent,
  ModalValidarRenovacionComponent,
  ModalValidarSubcategoriaComponent,
  ModalAsignarSancionComponent,
  ModalValidarCambiosActualizacionComponent,
  ModalEncuestaRenovacionComponent,
  ModalCambiarContrasenaAdminComponent,
  ModalConsultarUsuarioComponent,
  ModalAjusteRntComponent,
  TarjetaPasosComponent,
  MenuTemplate2Component,
  MenuTemplate3Component,
  MenuTemplate4Component,
  MenuTemplate5Component,
  VistaSeguridadComponent,
  ModalGenericoComponent,
  TablasComponent,
  TablasOrderComponent,
  AlertsComponent,
  ModalValidarActividadesEconomicasComponent,
  ModalCapturaDireccionComponent
];
//#endregion

import { SafeUrlPipe } from "./directives/pipes/safe-url.pipe";
import { ReportesCertificadoService } from '../components/core/containers/bandeja-principal/administrador/reportes/certificados/reportes-certificados.service';
import { ReporteSancionesPersonasComponent } from '../components/core/containers/bandeja-principal/administrador/reportes/reporte-sanciones-personas/reporte-sanciones-personas.component';
import { UtilService } from './services/util.service';
import { ModalCategoriaEstablecimientoComponent } from '../components/core/layouts/modal-categoria-establecimiento/modal-categoria-establecimiento/modal-categoria-establecimiento.component';
import { ModalListaCategoriasComponent } from './layouts/modal-lista-categorias/modal-lista-categorias.component';
import { ModalTiposSolicitudSubcategoriaComponent } from '../components/core/layouts/modal-tipos-solicitud-subcategoria/modal-tipos-solicitud-subcategoria.component';
import { ModalValidarRenovacionComponent } from '../components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component';
import { ModalValidarSubcategoriaComponent } from '../components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component';
import { ModalValidarCambiosActualizacionComponent } from '../components/core/layouts/modal-validar-cambios-actualizacion/modal-validar-cambios-actualizacion.component';
import { ModalEncuestaRenovacionComponent } from '../components/core/layouts/modal-encuesta-renovacion/modal-encuesta-renovacion.component';
import { ModalCambiarContrasenaAdminComponent } from '../components/core/layouts/modal-cambiar-contrasena-admin/modal-cambiar-contrasena-admin.component';
import { ModalConsultarUsuarioComponent } from '../components/core/layouts/modal-consultar-usuario/modal-consultar-usuario.component';
import { ModalAjusteRntComponent } from '../components/core/layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';
import { AssociateQuestionsComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional/components/associate-questions/associate-questions.component';
import { CampoAdicionalListComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional/components/campo-adicional-list/campo-adicional-list.component';
import { ReportesCertificadosComponent } from '../components/core/containers/bandeja-principal/administrador/reportes/certificados/reportes-certificados.component';
import { AjustesRntComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/ajustes-rnt/ajustes-rnt.component';
import { ReporteGeneralComponent } from '../components/core/containers/bandeja-principal/administrador/reportes/general/reporte-general.component';
import { AnotacionesAdminComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/anotaciones/anotaciones.component';
import { ReporteGeneralService } from '../components/core/containers/bandeja-principal/administrador/reportes/general/reporte-general.service';
import { NotificacionesComponent } from '../components/core/containers/bandeja-principal/prestador/notificaciones/notificaciones.component';
import { EncuestaSatisfaccionComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/encuesta-satisfaccion/encuesta-satisfaccion.component';
import { ModalEncuestaSatisfaccionPreguntasComponent } from '../components/core/layouts/modal-encuesta-satisfaccion-preguntas/modal-encuesta-satisfaccion-preguntas.component';
import { ModalEncuestaSatisfaccionComponent } from './layouts/modal-encuesta-satisfaccion/modal-encuesta-satisfaccion.component';
import { AsignarSancionesPersonaComponent } from '../components/core/containers/bandeja-principal/administrador/gestion/asignar-sanciones-persona/asignar-sanciones-persona.component';
import { ModalHistorialSancionPersonaComponent } from '../components/core/layouts/modal-historial-sancion-persona/modal-historial-sancion-persona.component';
import { ModalModificarSancionPersonaComponent } from '../components/core/layouts/modal-modificar-sancion-persona/modal-modificar-sancion-persona.component';
import { ModalAsignarSancionComponent } from '../components/core/layouts/modal-asignar-sancion/modal-asignar-sancion.component';
import { MunicipiosSinEstudioAutomaticoComponent } from '../components/core/containers/bandeja-principal/administrador/configuracion/municipios-sin-estudio-automatico/municipios-sin-estudio-automatico.component';

//#region pipes
export const PIPES = [FilterPipe, ActivoPipe, SafeUrlPipe];
//#endregion
